/**
 * Resource i18n module VẬN HÀNH (P4) — namespace `vanHanh`.
 * 9 màn: Tất cả đơn hàng (+tab Gán nhân viên) / Xếp nhặt / Kiểm tra / Đóng gói /
 * Điều phối / Giao hàng / Chi tiết đơn / Trung tâm thông báo.
 */
export const vanHanh = {
  titles: {
    donHangList: 'Tất cả đơn hàng',
    tabDanhSach: 'Danh sách đơn',
    tabGanNhanVien: 'Gán nhân viên',
    xepNhat: 'Xếp nhặt',
    kiemTra: 'Kiểm tra đơn',
    dongGoi: 'Đóng gói',
    dieuPhoi: 'Điều phối giao hàng',
    giaoHang: 'Giao hàng',
    chiTietDon: 'Chi tiết đơn hàng',
    thongBao: 'Trung tâm thông báo',
  },
  fields: {
    xuLy: 'Xử lý',
    viTri: 'Vị trí',
    tieuDe: 'Tiêu đề',
    kichThuoc: 'Kích thước',
    maHoaDon: 'Mã hóa đơn',
    khachHang: 'Khách hàng',
    trangThai: 'Trạng thái',
    trangThaiVanHanh: 'Trạng thái vận hành',
    chiNhanh: 'Chi nhánh',
    khachCanTra: 'Khách cần trả',
    khachDaTra: 'Khách đã trả',
    conLai: 'Còn lại',
    nguoiBan: 'Người bán',
    nguoiNhanHang: 'Người nhận hàng',
    nguoiNhat: 'Người nhặt',
    nguoiPhanCong: 'Người phân công',
    nguoiKiemTra: 'Người kiểm tra',
    nguoiDongGoi: 'Người đóng gói',
    nguoiDieuPhoi: 'Người điều phối',
    nguoiShip: 'Người giao',
    thoiGian: 'Thời gian',
    thoiGianPhanCong: 'Thời gian phân công',
    thoiGianBatDau: 'Thời gian bắt đầu',
    thoiGianHoanThanh: 'Thời gian hoàn thành',
    thoiGianNhan: 'Thời gian nhận',
    soLuong: 'Số lượng',
    soLuongDaNhat: 'Đã nhặt',
    soLuongDuKien: 'Dự kiến',
    soLuongThucTe: 'Thực tế',
    chenhLech: 'Chênh lệch',
    tongSoKien: 'Tổng số kiện',
    thongTinKienChiTiet: 'Thông tin kiện chi tiết',
    anhChungTu: 'Ảnh chứng từ',
    ghiChu: 'Ghi chú',
    lyDo: 'Lý do',
    maVanDon: 'Mã vận đơn',
    soLanIn: 'Số lần in',
    cotIn: 'In',
    nguonThayDoi: 'Nguồn thay đổi',
    nguoiThucHien: 'Người thực hiện',
    hanhDong: 'Thao tác',
    noiDung: 'Nội dung',
    watched: 'Đã xem',
    chuaDoc: 'Chưa đọc',
    phuongThucBanGiao: 'Phương thức bàn giao',
    id: 'ID',
    giaoHangKiot: 'Giao hàng Kiot',
    trangThaiDon: 'Trạng thái đơn',
    maDonHang: 'Mã đơn hàng',
    maKh: 'Mã KH',
    nhanVienBanHang: 'Nhân viên bán hàng',
    sdtNhanVien: 'SĐT nhân viên',
    sslSp: 'SSL SP',
    tongCan: 'Tổng cân',
    tongKhoi: 'Tổng khối',
    thoiCapNhat: 'Thời cập nhật',
    xemSua: 'Xem / Sửa',
    trangThaiGiaoHang: 'Trạng thái vận đơn',
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    ghiChuGiaoHang: 'Ghi chú giao hàng',
    soSanPham: 'Số SP',
    soLuongSanPham: 'SL sản phẩm',
    tongCanNang: 'Tổng cân nặng',
    tongTheTich: 'Tổng thể tích',
    diaChiGiaoHang: 'Địa chỉ giao hàng',
    hanGiaoHang: 'Hạn giao hàng',
    doUuTien: 'Ưu tiên',
    tongTien: 'Tổng tiền',
    ghiChuTrangThaiDon: 'Ghi chú trạng thái đơn',
    thoiGianTao: 'Ngày tạo',
    thoiGianCapNhat: 'Ngày cập nhật',
    ngayDatHang: 'Ngày đặt hàng',
    hangVanChuyen: 'Hãng vận chuyển',
    phanCong: 'Phân công',
    maHangHoa: 'Mã hàng hóa',
    tenHangHoa: 'Tên hàng hóa',
    dienThoai: 'Điện thoại',
    tenNguoiNhan: 'Người nhận',
    sdtNguoiNhan: 'SĐT người nhận',
    tongTienHang: 'Tổng tiền hàng',
    giamGia: 'Giảm giá',
  },
  filters: {
    thongTinDonSection: 'Thông tin đơn',
    phamViSection: 'Phạm vi kho',
    phamViTatCa: 'Tất cả',
    phamViCuaToi: 'Chỉ mình tôi',
    hintSection: 'Bộ lọc vận hành',
    hintBody: 'Lọc đơn theo trạng thái bước và người thực hiện',
    search: 'Tìm mã hóa đơn / tên khách hàng',
    trangThai: 'Trạng thái',
    nguoiThucHien: 'Người thực hiện',
    loaiThongBao: 'Loại thông báo',
    chiNhanh: 'Chi nhánh',
    khoVatLy: 'Kho vật lý',
    khoVatLyTatCa: 'Tất cả kho vật lý',
    khoVatLyDaChon: '{count} kho vật lý',
    khoVatLyEmpty: 'Không có kho vật lý',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    tatCa: 'Tất cả',
    maHoaDon: 'Mã hóa đơn',
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    maHangHoa: 'Mã hàng hóa',
    tenHangHoa: 'Tên hàng hóa',
    trangThaiGiaoHang: 'Trạng thái vận đơn',
    ngayDatHang: 'Ngày đặt hàng',
    ngayTao: 'Ngày tạo',
    hanGiaoHang: 'Hạn giao hàng',
    nguoiBan: 'Nhân viên bán hàng',
    nguoiNhat: 'Người nhặt hàng',
    nguoiKiemTra: 'Người kiểm tra',
    nguoiDongGoi: 'Người đóng gói',
    nguoiDieuPhoi: 'Người điều phối',
    nguoiShip: 'Người giao hàng',
    thoiGianSection: 'Thời gian',
    nhanVienSection: 'Nhân viên',
    nhanVienHint: 'Lọc theo người thực hiện từng bước',
  },
  placeholders: {
    search: 'Nhập mã hóa đơn hoặc tên khách hàng',
    lyDo: 'Nhập lý do',
    ghiChu: 'Nhập ghi chú',
    thongTinKienChiTiet: 'VD: Kiện 1: 5 áo; Kiện 2: 3 quần',
    chonNhanVien: 'Chọn nhân viên',
    maHoaDonMoi: 'Mã/ID hóa đơn đích',
  },
  // ===== 17 trạng thái vận hành =====
  trangThaiVanHanh: {
    MOI: 'Mới',
    CHO_NHAT: 'Chờ nhặt',
    DANG_NHAT: 'Đang nhặt',
    CHO_KIEM_TRA: 'Chờ kiểm tra',
    DANG_KIEM_TRA: 'Đang kiểm tra',
    CHO_DONG_GOI: 'Chờ đóng gói',
    DANG_DONG_GOI: 'Đang đóng gói',
    CHO_DIEU_PHOI: 'Chờ điều phối',
    DANG_DIEU_PHOI: 'Đang điều phối',
    CHO_GIAO_HANG: 'Chờ giao hàng',
    DANG_GIAO_HANG: 'Đang giao hàng',
    GIAO_MOT_PHAN: 'Giao một phần',
    DA_GIAO_HANG: 'Đã giao hàng',
    GIAO_THAT_BAI: 'Giao thất bại',
    DANG_GIAO_LAI: 'Đang giao lại',
    CHO_GIAO_LAI: 'Chờ giao lại',
    HUY_DON: 'Hủy đơn',
  },
  // ===== 8 trạng thái vận đơn đối tác (DHGiaoHangHoaDon) =====
  trangThaiVanDon: {
    CHO_XU_LY: 'Chờ xử lý',
    CHO_LAY_HANG: 'Chờ lấy hàng',
    DANG_GIAO: 'Đang giao',
    DA_GIAO: 'Đã giao',
    PHAT_KHONG_THANH_CONG: 'Phát không thành công',
    DANG_TRA_HANG: 'Đang trả hàng',
    TRA_HANG: 'Trả hàng',
    HUY: 'Hủy',
  },
  trangThaiPhanCong: {
    DA_PHAN_CONG: 'Đã phân công',
    DANG_NHAT: 'Đang nhặt',
    HOAN_THANH: 'Hoàn thành',
  },
  trangThaiKiemTra: {
    CHO_KIEM_TRA: 'Chờ kiểm tra',
    DANG_KIEM_TRA: 'Đang kiểm tra',
    HOAN_THANH: 'Hoàn thành',
  },
  trangThaiDongGoi: {
    CHO_DONG_GOI: 'Chờ đóng gói',
    DANG_DONG_GOI: 'Đang đóng gói',
    HOAN_THANH: 'Hoàn thành',
  },
  trangThaiDieuPhoi: {
    CHO_DIEU_PHOI: 'Chờ điều phối',
    DANG_DIEU_PHOI: 'Đang điều phối',
    HOAN_THANH: 'Hoàn thành',
  },
  trangThaiDonShip: {
    CHO_GIAO_HANG: 'Chờ giao',
    DANG_GIAO_HANG: 'Đang giao',
    DA_GIAO_HANG: 'Đã giao',
    GIAO_MOT_PHAN: 'Giao một phần',
    GIAO_THAT_BAI: 'Giao thất bại',
    CHO_GIAO_LAI: 'Chờ giao lại',
    DANG_GIAO_LAI: 'Đang giao lại',
  },
  trangThaiThanhToan: {
    CHUA_TT: 'Chưa thanh toán',
    TT_MOT_PHAN: 'Thanh toán một phần',
    DA_TT: 'Đã thanh toán',
  },
  nguonThayDoi: {
    USER: 'Người dùng',
    SYSTEM_JOB: 'Hệ thống',
    API: 'API',
  },
  phuongThucBanGiao: {
    MANUAL: 'Thủ công',
    AUTO_SUGGEST: 'Tự gợi ý',
    QR_SCAN: 'Quét QR',
  },
  loaiThongBao: {
    CODONHANGMOI: 'Đơn hàng mới',
    CODONHANGCANNHAT: 'Cần nhặt hàng',
    CODONHANGCANKIEMTRA: 'Cần kiểm tra',
    CODONHANGCANDONGGOI: 'Cần đóng gói',
    CODONHANGCANDIEUPHOI: 'Cần điều phối',
    CODONHANGCANGIAO: 'Cần giao hàng',
  },
  actions: {
    phanCongNhat: 'Phân công nhặt',
    xemChiTiet: 'Xem chi tiết',
    taoPhanCong: 'Tạo phân công nhặt',
    batDauNhat: 'Bắt đầu nhặt',
    hoanThanhNhat: 'Hoàn thành nhặt',
    capNhatSoLuongNhat: 'Cập nhật số lượng nhặt',
    thamGiaNhat: 'Tham gia nhặt',
    xoaPhanCong: 'Xóa phân công',
    batDauKiemTra: 'Bắt đầu kiểm tra',
    luuKiemTra: 'Lưu kết quả kiểm tra',
    hoanThanhKiemTra: 'Hoàn thành kiểm tra',
    xoaKiemTra: 'Xóa phiếu kiểm tra',
    batDauDongGoi: 'Bắt đầu đóng gói',
    hoanThanhDongGoi: 'Hoàn thành đóng gói',
    thamGiaDongGoi: 'Tham gia đóng gói',
    taiAnh: 'Tải ảnh lên',
    xoaAnh: 'Xóa ảnh',
    xoaDongGoi: 'Xóa phiếu đóng gói',
    ganNguoiDieuPhoi: 'Gán người điều phối',
    batDauDieuPhoi: 'Bắt đầu điều phối',
    hoanThanhDieuPhoi: 'Hoàn thành điều phối',
    thamGiaDieuPhoi: 'Tham gia điều phối',
    xoaDieuPhoi: 'Xóa phiếu điều phối',
    batDauGiao: 'Bắt đầu giao hàng',
    giaoThanhCong: 'Giao thành công',
    giaoMotPhan: 'Giao một phần',
    giaoThatBai: 'Giao thất bại',
    batDauGiaoLai: 'Bắt đầu giao lại',
    ganLaiNguoiShip: 'Gán lại người giao',
    thamGiaGiao: 'Tham gia giao',
    xoaDonShip: 'Xóa đơn ship',
    resetDon: 'Reset đơn hàng',
    overrideTrangThai: 'Ép trạng thái',
    chuyenDoiLienKet: 'Chuyển đổi liên kết',
    inPhieuDongGoi: 'In phiếu đóng gói',
    inPhieuGiaoHang: 'In phiếu giao hàng',
    in: 'In',
    ganNhanVien: 'Gán nhân viên',
    gan: 'Gán',
    xemLichSuNhat: 'Xem lịch sử nhặt',
    danhDauDaXem: 'Đánh dấu đã xem',
    xemTatCaDaXem: 'Đánh dấu tất cả đã xem',
    xoaThongBao: 'Xóa thông báo',
    choPhepThongBao: 'Bật thông báo đẩy',
    lamMoi: 'Làm mới',
  },
  messages: {
    loadError: 'Không tải được danh sách vận hành',
    batDauNhatThanhCong: 'Bắt đầu nhặt hàng thành công',
    hoanThanhNhatThanhCong: 'Hoàn thành nhặt hàng thành công — đã tạo phiếu kiểm tra',
    capNhatSoLuongThanhCong: 'Cập nhật số lượng nhặt thành công',
    taoPhanCongThanhCong: 'Tạo phân công nhặt thành công',
    capNhatPhanCongThanhCong: 'Cập nhật phân công nhặt thành công',
    xoaPhanCongThanhCong: 'Xóa phân công nhặt thành công — đơn về trạng thái Mới',
    thamGiaThanhCong: 'Tham gia thành công',
    batDauKiemTraThanhCong: 'Bắt đầu kiểm tra thành công',
    luuKiemTraThanhCong: 'Lưu kết quả kiểm tra thành công',
    hoanThanhKiemTraThanhCong: 'Hoàn thành kiểm tra thành công — đã tạo phiếu đóng gói',
    xoaKiemTraThanhCong: 'Xóa phiếu kiểm tra thành công',
    batDauDongGoiThanhCong: 'Bắt đầu đóng gói thành công',
    capNhatDongGoiThanhCong: 'Cập nhật đóng gói thành công',
    hoanThanhDongGoiThanhCong: 'Hoàn thành đóng gói thành công — đã tạo điều phối',
    xoaDongGoiThanhCong: 'Xóa phiếu đóng gói thành công',
    taiAnhThanhCong: 'Tải ảnh lên thành công',
    xoaAnhThanhCong: 'Xóa ảnh thành công',
    ganNguoiThanhCong: 'Gán người thành công',
    batDauDieuPhoiThanhCong: 'Bắt đầu điều phối thành công',
    hoanThanhDieuPhoiThanhCong: 'Hoàn thành điều phối thành công — đã tạo đơn ship',
    xoaDieuPhoiThanhCong: 'Xóa phiếu điều phối thành công',
    batDauGiaoThanhCong: 'Bắt đầu giao hàng thành công',
    giaoThanhCongThanhCong: 'Ghi nhận giao thành công',
    giaoMotPhanThanhCong: 'Ghi nhận giao một phần',
    giaoThatBaiThanhCong: 'Ghi nhận giao thất bại',
    giaoLaiThanhCong: 'Bắt đầu giao lại thành công',
    ganLaiShipThanhCong: 'Gán lại người giao thành công',
    xoaDonShipThanhCong: 'Xóa đơn ship thành công',
    resetThanhCong: 'Reset đơn hàng thành công',
    overrideThanhCong: 'Ép trạng thái thành công',
    chuyenDoiLienKetThanhCong: 'Chuyển đổi liên kết thành công',
    danhDauDaXemThanhCong: 'Đánh dấu đã xem thành công',
    xoaThongBaoThanhCong: 'Xóa thông báo thành công',
    chuaCoDuLieu: 'Chưa có dữ liệu',
    chuaCoDuLieuKhopLoc: 'Không có dữ liệu khớp bộ lọc',
    canChonNhanVien: 'Vui lòng chọn ít nhất một nhân viên',
    canNhapLyDo: 'Vui lòng nhập lý do',
    canNhapSoKien: 'Vui lòng nhập tổng số kiện',
    canNhapMaHoaDonMoi: 'Vui lòng nhập hóa đơn đích',
    coWarnings: 'Thao tác hoàn tất kèm cảnh báo',
  },
  xacNhan: {
    batDauNhat: 'Bắt đầu nhặt đơn {maHoaDon}?',
    hoanThanhNhat: 'Hoàn thành nhặt đơn {maHoaDon}? Sẽ tạo phiếu kiểm tra và chuyển đơn sang chờ kiểm tra.',
    xoaPhanCong: 'Xóa phân công nhặt của đơn {maHoaDon}? Đơn sẽ trở về trạng thái Mới.',
    batDauKiemTra: 'Bắt đầu kiểm tra đơn {maHoaDon}? Bạn sẽ là người kiểm tra.',
    hoanThanhKiemTra: 'Hoàn thành kiểm tra đơn {maHoaDon}? Sẽ tạo phiếu đóng gói và chuyển đơn sang chờ đóng gói.',
    xoaKiemTra: 'Xóa phiếu kiểm tra của đơn {maHoaDon}? Đơn sẽ trở về trạng thái đang nhặt.',
    batDauDongGoi: 'Bắt đầu đóng gói đơn {maHoaDon}?',
    hoanThanhDongGoi:
      'Hoàn thành đóng gói đơn {maHoaDon}? Sẽ tạo phiếu điều phối.',
    xoaDongGoi: 'Xóa phiếu đóng gói của đơn {maHoaDon}? Đơn sẽ trở về trạng thái đang kiểm tra.',
    batDauDieuPhoi: 'Bắt đầu điều phối đơn {maHoaDon}?',
    hoanThanhDieuPhoi: 'Hoàn thành điều phối đơn {maHoaDon}? Sẽ tạo đơn ship và chuyển đơn sang chờ giao hàng.',
    xoaDieuPhoi: 'Xóa phiếu điều phối của đơn {maHoaDon}? Đơn sẽ trở về trạng thái đang đóng gói.',
    batDauGiao: 'Bắt đầu giao đơn {maHoaDon}?',
    giaoThanhCong: 'Xác nhận giao THÀNH CÔNG đơn {maHoaDon}?',
    giaoMotPhan: 'Xác nhận giao MỘT PHẦN đơn {maHoaDon}?',
    giaoThatBai: 'Xác nhận giao THẤT BẠI đơn {maHoaDon}?',
    giaoLai: 'Bắt đầu giao lại đơn {maHoaDon}?',
    xoaDonShip: 'Xóa đơn ship của đơn {maHoaDon}? Đơn sẽ trở về trạng thái chờ điều phối.',
    resetDon: 'Reset đơn {maHoaDon} về trạng thái "{trangThai}"?',
    overrideTrangThai: 'Ép trạng thái đơn {maHoaDon} sang "{trangThai}"? Thao tác quản trị — dùng khi dữ liệu lệch.',
    chuyenDoiLienKet:
      'Chuyển toàn bộ workflow của đơn {maHoaDon} sang đơn đích? Đơn hiện tại sẽ bị HỦY.',
    xoaThongBao: 'Xóa thông báo này?',
    xoaAnh: 'Xóa ảnh này?',
  },
  xepNhat: {
    chuaPhanCongTitle: 'Hóa đơn chờ phân công nhặt',
    chuaPhanCongHint: 'Đơn mới vào workflow chưa có người nhặt',
    taoPhanCongTitle: 'Tạo phân công nhặt',
    capNhatPhanCongTitle: 'Cập nhật phân công nhặt',
    chonNguoiNhat: 'Người nhặt',
    chonDongHang: 'Dòng hàng nhặt',
    tatCaDong: 'Tất cả dòng (mặc định)',
    lichSuNhatTitle: 'Lịch sử nhặt',
    sttLan: 'Lần',
    soLuongTangThem: 'Số lượng tăng thêm',
    daNhatDu: 'Đủ',
    conThieu: 'Thiếu {so}',
    tieuDeForm: 'Phân công nhặt — {maHoaDon}',
  },
  kiemTra: {
    tieuDeForm: 'Kiểm tra — {maHoaDon}',
    hintDuKienVsThucTe: 'Nhập số lượng thực tế từng dòng — dòng lệch sẽ được tô màu',
    dongDu: 'Đủ',
    dongThieu: 'Thiếu {so}',
    dongDuThua: 'Dư {so}',
    nguoiKiemTraHint: 'Người bấm "Bắt đầu kiểm tra" sẽ được ghi nhận là người kiểm tra',
  },
  dongGoi: {
    tieuDeForm: 'Đóng gói — {maHoaDon}',
    anhChungTuHint: 'Ảnh kiện hàng sau khi đóng (làm bằng chứng bàn giao)',
    phieuKhoLienKet: 'Phiếu kho liên kết',
  },
  dieuPhoi: {
    tieuDeForm: 'Điều phối — {maHoaDon}',
    phanNhanh: 'Phân nhánh',
    giaoNoiBo: 'Giao nội bộ',
    banGiaoHang: 'Bàn giao hãng vận chuyển',
    banGiaoHangHint: 'Đơn giao hãng: hoàn tất điều phối là bàn giao hãng — theo dõi vận đơn qua module vận chuyển',
    nguoiShipKhiHoanThanh: 'Người giao nội bộ (khi hoàn thành)',
    chuaCoVanDon: 'Chưa có mã vận đơn',
  },
  giaoHang: {
    tieuDeForm: 'Giao hàng — {maHoaDon}',
    ketQuaGiao: 'Kết quả giao',
    chiTietGiaoMotPhan: 'Chi tiết từng dòng đã giao',
    soLuongGiaoLanNay: 'Số lần giao',
    soLuongGiao: 'SL giao',
    anhBangChung: 'Ảnh bằng chứng giao hàng',
    thongTinGhiNhan: 'Thông tin ghi nhận giao hàng',
    canNguoiShip: 'Đơn chưa có người giao — hãy gán người trước khi bắt đầu',
  },
  chiTiet: {
    timeline: 'Lịch sử trạng thái',
    buoc: 'Bước',
    buoc1: 'Xếp nhặt',
    buoc2: 'Kiểm tra',
    buoc3: 'Đóng gói',
    buoc4: 'Điều phối',
    buoc5: 'Giao hàng',
    chuaCoBuoc: 'Chưa có dữ liệu bước này',
    qrBanGiao: 'Mã QR bàn giao',
    qrHint: 'Người nhận quét mã để tham gia bước của họ',
    inPhieu: 'In phiếu',
    trangThaiCu: 'Trạng thái cũ',
    trangThaiMoi: 'Trạng thái mới',
    thongTinHoaDon: 'Thông tin hóa đơn',
    thongTinKhachHang: 'Thông tin khách hàng',
    thanhToan: 'Thanh toán',
    cacBuoc: 'Các bước xử lý',
  },
  flow: {
    tabThongTin: 'Thông tin đơn hàng',
    tabChiTiet: 'Chi tiết đơn hàng',
    tabFlow: 'Flow đơn hàng',
    tieuDe: 'Quy trình xử lý đơn hàng',
    moRongTatCa: 'Mở rộng tất cả',
    thuGonTatCa: 'Thu gọn tất cả',
    buocDonMoi: 'Đơn hàng mới',
    buocNhat: 'Nhặt hàng',
    buocKiem: 'Kiểm hàng',
    buocDongGoi: 'Đóng gói',
    buocDieuPhoi: 'Điều phối',
    buocGiao: 'Giao hàng',
    ketThucNhat: 'Kết thúc nhặt',
    ketThucKiemTra: 'Kết thúc kiểm tra',
    ketThucDongGoi: 'Kết thúc đóng gói',
    ketThucDieuPhoi: 'Kết thúc điều phối',
    nguoiThucHien: 'Người thực hiện',
    buocHienTai: 'Bước hiện tại',
    ghiChu: 'Ghi chú',
    tongSoKien: 'Tổng số kiện',
    ghiChuDongHang: 'Ghi chú khi đóng hàng',
    lichSu: 'Lịch sử thay đổi trạng thái',
    trangThaiHienTai: 'Trạng thái hiện tại',
    chuaCoLichSu: 'Chưa có lịch sử thay đổi trạng thái.',
    ghiChuDon: 'Ghi chú đơn',
    nguoiTao: 'Người tạo',
    hanGiaoHang: 'Hạn giao hàng',
    doUuTien: 'Độ ưu tiên',
    dienThoaiNhan: 'SĐT người nhận',
    doiTacGiaoHang: 'Đối tác giao hàng',
    buocXong: 'Hoàn thành',
    buocDangLam: 'Đang thực hiện',
    buocChuaToi: 'Chưa tới',
    hienTai: 'Hiện tại',
    tienTrinh: 'Tiến trình',
  },
  donHang: {
    sapXepTheoCot: 'Sắp xếp theo cột',
    tongHopSanPham: 'Tổng hợp SP',
    tongHopSanPhamTitle: 'Danh sách sản phẩm tổng hợp',
    tongHopSanPhamTom: '{soDon} đơn · {soMa} mã SP · SL: {soLuong}',
    tongHopSanPhamTrong: 'Không có chi tiết sản phẩm từ các đơn đã chọn',
    sapXep: 'Sắp xếp',
    sapXepTheoMa: 'Mã',
    sapXepTheoTen: 'Tên',
    chiaTheoDon: 'Chia đơn',
    khongCoThaoTac: 'Không có thao tác',
    resetTitle: 'Reset đơn hàng',
    khongCoTrangThaiReset: 'Không có trạng thái hợp lệ để reset đơn hàng này',
    donHuy: 'Đơn hủy',
    overrideTitle: 'Ép trạng thái đơn',
    chuyenDoiLienKetTitle: 'Chuyển đổi liên kết đơn',
    hoaDonMoiId: 'Hóa đơn đích',
    trangThaiMucTieu: 'Trạng thái đích',
    warnings: 'Cảnh báo',
    khongCoNguoi: '—',
    daGan: 'Đã gán {count} người',
    chuaGan: 'Chưa gán',
    ganBuoc: 'Gán {buoc}',
    assignPicker: 'người nhặt',
    assignInspector: 'người kiểm tra',
    assignPacker: 'người đóng gói',
    assignDispatcher: 'người điều phối',
    assignShipper: 'người giao',
    ganNhanVienTitle: 'Gán nhân viên ({count} đơn)',
    ganNhanVienHint: 'Chọn nhân viên cho bước theo trạng thái đơn đã chọn',
    khacBuoc: 'Các đơn chọn được gán ở bước khác ({buoc}) — bỏ chọn hoặc gán riêng',
    inspectorHint: 'Bước kiểm tra không gán trước — người bấm "Bắt đầu kiểm tra" tự nhận',
    nutNhat: 'Nhặt',
    nutDong: 'Đóng',
    nutGiao: 'Giao',
    nutDieuPhoi: 'Điều',
    sapXepMacDinh: 'Ưu tiên (mặc định)',
    sapXepNgayDatMoi: 'Ngày đặt hàng mới nhất',
    sapXepNgayDatCu: 'Ngày đặt hàng cũ nhất',
    sapXepTaoMoi: 'Tạo đơn mới nhất',
    sapXepTaoCu: 'Tạo đơn cũ nhất',
    sapXepHanXa: 'Hạn giao hàng xa nhất',
    sapXepHanGan: 'Hạn giao hàng gần nhất',
    xemDayDu: 'Xem chi tiết đầy đủ',
    khongTaiDuocChiTiet: 'Không tải được chi tiết đơn',
    thongTinGiao: 'Thông tin giao hàng',
    daChonDon: 'Đã chọn: {count} đơn',
    soSanPhamTong: 'Số sản phẩm',
    soLuongSanPhanTong: 'Số lượng sản phẩm',
    tongCanNangChon: 'Tổng cân nặng',
    tongTheTichChon: 'Tổng thể tích',
    boChon: 'Bỏ chọn',
    ganDon: 'Gán đơn',
    ghiDe: 'Ghi đè',
    chuyenWorkflow: 'Chuyển workflow',
    bulkOverrideTitle: 'Ghi đè trạng thái nhiều đơn',
    bulkOverrideBoQua: 'Bỏ qua {count} đơn đã giao / đã hủy',
    lyDoOverride: 'Lý do ghi đè',
    giaoThanhCongBtn: 'Giao hàng thành công',
    giaoThatBaiBtn: 'Giao hàng thất bại',
    overrideHoanTat: 'Ghi đè hoàn tất: {ok}/{total} đơn thành công',
    choXuLy: 'Chờ xử lý',
    thanhCong: 'Thành công',
    thatBai: 'Thất bại',
    khongCoDonHopLe: 'Không có đơn hợp lệ để ghi đè',
    transferTitle: 'Chuyển workflow đơn',
    transferHint:
      'Hủy workflow của đơn NGUỒN (đơn bị hủy) và đưa đơn ĐÍCH vào trạng thái Mới. Hai đơn phải cùng chi nhánh, đơn đích chưa có workflow.',
    transferNguonHint: 'Workflow của đơn này sẽ bị hủy',
    transferDichHint: 'Đơn này sẽ vào trạng thái Mới',
    donNguon: 'Đơn nguồn',
    donDich: 'Đơn đích',
    doiVaiTro: 'Đổi vai trò nguồn/đích',
    can2Don: 'Chọn đúng 2 đơn để chuyển workflow',
    inPhieu: 'In phiếu',
    inPhieuGiaoLogo: 'Phiếu giao hàng (có logo, địa chỉ)',
    inPhieuGiaoToiGian: 'Phiếu giao hàng (tối giản)',
    inPhieuDongGoiLogo: 'Phiếu đóng gói (có logo, địa chỉ)',
    inPhieuDongGoiToiGian: 'Phiếu đóng gói (tối giản)',
    chonMauIn: 'Chọn mẫu in',
    nhomCoLogo: 'Có logo, địa chỉ',
    nhomKhongLogo: 'Không logo, địa chỉ',
    nhomKhac: 'Khác',
    mauIn: {
      PHIEU_GIAO_HANG_V1: 'Phiếu giao hàng V1',
      HOA_DON_BAN_HANG: 'Hóa đơn bán hàng V1',
      PHIEU_GIAO_HANG_V2: 'Phiếu giao hàng V2',
      HOA_DON_BAN_HANG_V2: 'Hóa đơn bán hàng V2',
      PHIEU_DONG_GOI: 'Phiếu đóng gói',
    },
    inPhieuDaIn: 'In phiếu (đã in {count} lần)',
    daTaoPhieuIn: 'Đã tạo {count} phiếu để in',
    boQuaDonHuy: 'Bỏ qua {count} đơn đã hủy',
    xuatExcel: 'Xuất Excel',
    xuatExcelDon: 'Xuất Excel danh sách đơn',
    xuatExcelChiTiet: 'Xuất Excel chi tiết hàng hóa',
    xuatExcelThanhCong: 'Xuất file Excel thành công!',
    xuatExcelLoi: 'Xuất file Excel thất bại',
    fileExcelDon: 'Danh sách đơn vận hành',
    fileExcelChiTiet: 'Chi tiết đơn vận hành',
    thuKhac: 'Thu khác',
  },
  thongBao: {
    trungTam: 'Trung tâm thông báo',
    danhSach: 'Danh sách thông báo',
    thongBaoChung: 'Thông báo chung',
    chuaXemTatCa: 'Đánh dấu tất cả đã xem',
    khongCoThongBao: 'Không có thông báo',
    choPhepPush: 'Bật thông báo đẩy trên thiết bị này',
    pushDaBat: 'Đã bật thông báo đẩy',
    pushBiTuChoi: 'Trình duyệt từ chối quyền thông báo',
    pushLoiCauHinh: 'Chưa cấu hình Firebase (REACT_APP_FIREBASE_*) — thông báo đẩy tắt',
    diDenDon: 'Đi tới đơn hàng',
  },
  in: {
    phieuDongGoi: 'PHIẾU ĐÓNG GÓI',
    phieuGiaoHang: 'PHIẾU GIAO HÀNG',
    chiNhanh: 'Chi nhánh',
    khachHang: 'Khách hàng',
    nguoiBan: 'Người bán',
    nguoiNhan: 'Người nhận',
    nguoiDongGoi: 'Người đóng gói',
    nguoiShip: 'Người giao',
    chiTietHang: 'Chi tiết hàng hóa',
    stt: 'STT',
    maHang: 'Mã hàng',
    tenHang: 'Tên hàng',
    soLuong: 'SL',
    donVi: 'ĐVT',
    ghiChu: 'Ghi chú',
    tongCong: 'Tổng cộng',
    thoiGianIn: 'Thời gian in',
    inLanThu: 'In lần thứ',
    khachCanTra: 'Khách cần trả',
    khachDaTra: 'Khách đã trả',
    conLai: 'Còn lại',
    trangThaiThanhToan: 'Thanh toán',
    qrBanGiao: 'Quét QR bàn giao',
    donVanDon: 'Vận đơn',
    ketQua: 'Kết quả',
  },
  buoc: {
    gan: 'Gán nhặt',
    nhat: 'Nhặt',
    kiem: 'Kiểm',
    dong: 'Đóng',
    dieu: 'Điều',
    giao: 'Giao',
    giaoLai: 'Giao lại',
    chiTiet: 'Chi tiết',
  },
  aria: {
    moMenuThaoTac: 'Mở menu thao tác',
    xemChiTiet: 'Xem chi tiết đơn',
    chonCotHienThi: 'Chọn cột hiển thị',
    moMenuSapXep: 'Mở menu sắp xếp',
    moRongDong: 'Mở rộng chi tiết dòng',
    selectAllPage: 'Chọn tất cả hàng trên trang này',
    selectRow: 'Chọn hàng',
  },
  // ===== impl-c =====
  implC: {
    common: {
      xoa: 'Xóa',
      tonKho: 'Tồn kho',
    },
    xepNhat: {
      nhatDu: 'Nhặt đủ',
      datLai: 'Đặt lại',
      viewerOnly: 'Đơn đang do {nguoi} nhặt — bạn chỉ xem, không thao tác thêm.',
      viewerOnlyKhongTen:
        'Đơn đang được gán cho người khác nhặt — bạn chỉ xem, không thao tác thêm.',
      daDuToanBo: 'Tất cả dòng đã nhặt đủ',
      daVeKhongToanBo: 'Số lượng nhặt đã về 0',
    },
    kiemTra: {
      kiemDu: 'Kiểm đủ',
    },
    chiTietDon: {
      tabSanPham: 'Sản phẩm',
      daKiem: 'Đã kiểm',
      kgThung: 'KG/thùng',
      m3Thung: 'M³/thùng',
      slThung: 'SL/thùng',
      soThung: 'Số thùng',
      kichThuoc: 'D×R×C',
      viTri: 'Vị trí',
      tongCanNang: 'Tổng cân nặng (kg)',
      tongTheTich: 'Tổng thể tích',
      mocCaoNhat: 'Mốc cao nhất workflow',
      trangThaiHienTai: 'Trạng thái hiện tại',
      sheetName: 'Chi tiết đơn hàng',
      filePrefix: 'Chi_tiet_don',
    },
    tongHopSp: {
      tieuDe: 'Danh sách sản phẩm tổng hợp',
      thongKe: '{soDon} đơn · {soMa} mã SP · SL: {soLuong}',
      sapXep: 'Sắp xếp',
      ma: 'Mã',
      ten: 'Tên',
      chiaDon: 'Chia đơn',
      dangTai: 'Đang tổng hợp sản phẩm…',
      khongCoDuLieu: 'Không có chi tiết sản phẩm từ các đơn đã chọn.',
    },
    gallery: {
      xem: 'Xem ({so} ảnh)',
      moTabMoi: 'Mở ảnh trong tab mới',
      truoc: 'Ảnh trước',
      sau: 'Ảnh sau',
    },
    kien: {
      tabThongTin: 'Thông tin',
      tabInPhieu: 'In phiếu',
      danhSachKien: 'Danh sách kiện',
      tong: 'Tổng {so} kiện',
      chan: 'Chẵn',
      le: 'Lẻ',
      gop: 'Gộp',
      soKienVatLy: 'SL kiện',
      loai: 'Loại',
      sanPham: 'Sản phẩm',
      soLuongKien: 'SL kiện lặp',
      taoGop: 'Tạo kiện gộp',
      goiYCoBan: 'Gợi ý kiện cơ bản',
      goiYThongMinh: 'Gợi ý kiện thông minh',
      inA4: 'In phiếu kiện A4',
      inA5: 'In phiếu kiện A5',
      taoGopTieuDe: 'Tạo kiện gộp',
      daChon: 'Đã chọn {chon}/{tong} sản phẩm',
      slCo: 'SL có',
      khongConSpGop: 'Không còn sản phẩm nào đủ điều kiện gộp',
      taoGopThanhCong: 'Tạo kiện gộp thành công!',
      can2Sp: 'Kiện gộp phải có ít nhất 2 sản phẩm!',
      loiSl: 'Số lượng vượt quá số lượng có sẵn:',
      loiSlChiTiet: '{ten}: yêu cầu {yeucau} nhưng chỉ có {co} sẵn có',
      daLuu: 'Kiện đã lưu',
      xemTabInPhieu: 'xem/sửa ở tab "In phiếu"',
      phieuKien: 'PHIẾU KIỆN',
      phieuKienGop: 'PHIẾU KIỆN GỘP',
      kien: 'Kiện',
      ngay: 'Ngày',
      gio: 'Giờ',
      chuKy: 'Chữ ký người đóng gói',
      maDon: 'Mã đơn',
      daTaoTrang: 'Đã tạo {so} trang phiếu kiện để in ({khogiay})!',
      chuaCoKien: 'Chưa có kiện — bấm "Gợi ý kiện cơ bản" để tạo',
    },
    g18: {
      chuaCoPhieu: 'Đơn chưa có phiếu {buoc}',
      xemPhieuDongGoi: 'Phiếu đóng gói',
      xemPhieuDieuPhoi: 'Phiếu điều phối',
      xemDonShip: 'Đơn giao hàng',
      bulkGiao: 'Giao hàng',
      bulkDieuPhoi: 'Điều phối nhiều đơn',
    },
    g19: {
      tabThongTinDon: 'Thông tin đơn',
      tabFlowDon: 'Flow đơn',
      thongTinCoBan: 'Thông tin cơ bản',
      nguoiTao: 'Người tạo',
      buocDonMoi: 'Đơn hàng mới',
      moTa: 'Mô tả',
      trangThaiCaoNhat: 'Trạng thái cao nhất đơn từng đạt',
      lichSuThayDoi: 'Lịch sử thay đổi trạng thái',
      moRongTatCa: 'Mở rộng tất cả',
      thuGonTatCa: 'Thu gọn tất cả',
      moRong: 'Mở rộng',
      thuGon: 'Thu gọn',
      anh: 'Ảnh',
      ghiChuSp: 'Ghi chú SP',
      chuaCo: 'Chưa có',
      khongCoGhiChu: 'Không có ghi chú',
    },
  },
  // ===== impl-a =====
  implA: {
    ganTuanTuHint: 'Các đơn đã chọn cùng trạng thái. Hệ thống xử lý lần lượt từng đơn — không cần đổi chi nhánh đang làm việc.',
    logDangXuLy: '… {ma}: đang xử lý',
    logOk: '✓ {ma}: xong',
    logLoi: '✗ {ma}: {msg}',
    loiChung: 'Lỗi',
    ketQuaHonHop: 'Thành công {ok} đơn, lỗi {fail} đơn: {loi}',
    thatBaiHet: 'Không đơn nào xử lý thành công — xem nhật ký bên dưới',
    dangGan: 'Đang gán…',
    dieuPhoiNhieuDon: 'Điều phối loạt',
    dieuPhoiNhieuDonTitle: 'Điều phối nhiều đơn ({count} đơn)',
    dieuPhoiAutoChainHint: 'Với mỗi đơn chờ / đang điều phối: Tham gia → Bắt đầu → Hoàn thành (kèm người giao hàng). Đơn không đủ điều kiện sẽ được bỏ qua.',
    dieuPhoiBoQua: 'Bỏ qua {count} đơn không ở trạng thái chờ / đang điều phối',
    dieuPhoiKhongHopLe: 'Không có đơn hợp lệ để điều phối (chờ / đang điều phối)',
    nguoiGiaoLabel: 'Người giao hàng',
    ghiChuDieuPhoi: 'Ghi chú điều phối (áp dụng khi hoàn thành)',
    batDauDieuPhoi: 'Bắt đầu điều phối',
    dangDieuPhoi: 'Đang điều phối…',
    dieuPhoiKetQua: 'Đã điều phối {ok}/{total} đơn, {fail} lỗi',
    giaoNhieuDon: 'Giao hàng loạt',
    giaoNhieuDonTitle: 'Giao hàng hàng loạt ({count} đơn)',
    giaoAutoChainHint: 'Với mỗi đơn: Tham gia đơn ship (nếu cần) → Bắt đầu giao → Hoàn tất theo kết quả chọn. Ảnh và ghi chú áp dụng cho mọi đơn đã chọn.',
    giaoBoQua: 'Bỏ qua {count} đơn không đủ điều kiện (chưa có đơn ship hoặc trạng thái không phù hợp)',
    giaoKhongHopLe: 'Không có đơn hợp lệ (thiếu đơn ship hoặc trạng thái không phù hợp)',
    giaoHoanThanh: 'Hoàn thành',
    giaoMotPhan: 'Giao một phần',
    giaoThatBai: 'Thất bại',
    ghiChuGiaoMotPhan: 'Ghi chú giao một phần',
    ghiChuGiaoThanhCong: 'Ghi chú giao thành công',
    ghiChuGiaoThatBai: 'Ghi chú / lý do giao thất bại',
    anhGiaoChung: 'Ảnh giao hàng (chọn 1 lần — hệ thống tải lên riêng cho từng đơn)',
    canLyDoGiaoThatBai: 'Cần nhập lý do giao thất bại',
    thucHien: 'Thực hiện',
    dangGiao: 'Đang giao…',
    giaoKetQua: 'Đã xử lý {ok}/{total} đơn, {fail} lỗi',
    tuyChon: 'Tùy chọn',
    xuatExcelCotHienThi: 'Xuất Excel (cột đang hiển thị)',
    soLanInHint: 'Đơn đã in {count} lần',
    lichSuTrangThai: 'Lịch sử trạng thái',
    chuaCoLichSu: 'Chưa có lịch sử trạng thái',
    trangThaiCaoNhatNguon: 'Trạng thái cao nhất đơn nguồn từng đạt',
    dichSeVaoMoi: 'đơn đích sẽ vào trạng thái Mới (MOI)',
    assignScopeTatCa: 'Tất cả',
    assignScopeChiToi: 'Chỉ tôi',
    assignScopeHint: 'Phạm vi đơn hiển thị theo người đang giữ bước',
    assignScopeAria: 'Phạm vi nhân viên',
    tongHopSp: 'Tổng hợp SP',
    nhomHang: 'Nhóm hàng',
    thoiGianTheoBuoc: 'Thời gian theo bước',
    buocNhat: 'Nhặt',
    buocKiemTra: 'Kiểm tra',
    buocDongGoi: 'Đóng gói',
    buocDieuPhoi: 'Điều phối',
    buocGiaoHang: 'Giao hàng',
    tu: 'Từ',
    den: 'Đến',
    chiTietNhat: 'Chi tiết nhặt',
    chuaCoPhanCongNhat: 'Đơn chưa có phiếu phân công nhặt — tạo phân công trước',
    chiTietKiemTra: 'Chi tiết kiểm tra',
    chuaCoPhieuKiemTra: 'Đơn chưa có phiếu kiểm tra (phiếu được tạo khi hoàn thành nhặt)',
  },
  // ===== be-vanhanh =====
  beVanHanh: {
    dieuPhoiView: {
      densityLabel: 'Mật độ hiển thị',
      densityDefault: 'Thường',
      densityCompact: 'Gọn',
      densityUltra: 'Siêu gọn',
      tableViewLabel: 'Bố cục bảng',
      singleTable: 'Một bảng',
      splitTable: 'Chia đôi',
      zoomOut: 'Thu nhỏ',
      zoomIn: 'Phóng to',
      zoomReset: 'Đặt lại zoom mặc định (100%)',
      fullscreen: 'Toàn màn hình',
      fullscreenClose: 'Đóng',
      reset: 'Mặc định',
      resetHint: 'Đặt lại mật độ, zoom và bố cục về mặc định',
    },
  },
}
